import { cx } from '@linaria/core';
import 'react';
import { useNotifier } from '@provider/notifier';
import { units } from '@ui/css';
import { Tooltip, CircularButton } from '@ui/kit';
import { SpeakerIcon } from '@ui/kit/icons';
import { describeArcPath } from '@utils/common';
import { useAudio, useActivityIndicator } from '@utils/react';
import { loader, stopIcon, progressCircle, button } from './_audio-player.circled.style.js';
import { jsx } from 'react/jsx-runtime';

function CircledAudioPlayer(props) {
  const notifier = useNotifier();
  const audio = useAudio({
    src: props.src,
    autoplay: props.autoplay ?? false,
    notifier
  });
  const isLoading = useActivityIndicator(audio.isLoading, {
    delayMs: 1000
  });
  const onClick = evt => {
    evt.stopPropagation();
    if (audio.isLoading || audio.isPlaying) {
      audio.pause();
      audio.seek(0);
    } else {
      audio.resume();
    }
  };
  const icon = (() => {
    if (isLoading.isActive()) {
      return {
        key: "loader",
        element: /*#__PURE__*/jsx("span", {
          className: loader
        })
      };
    }
    if (!audio.isPlaying) {
      return {
        key: "play",
        element: /*#__PURE__*/jsx(SpeakerIcon, {
          style: {
            marginLeft: "2px",
            height: units.px(props.size === "small" ? 14 : props.size === "large" ? 18 : 16)
          }
        })
      };
    } else {
      return {
        key: "stop",
        element: /*#__PURE__*/jsx("div", {
          className: stopIcon,
          "data-size": props.size
        })
      };
    }
  })();
  const currentProgress = !audio.timeElapsedMs || !audio.durationMs ? 0 : Number(audio.timeElapsedMs) / Number(audio.durationMs);
  return /*#__PURE__*/jsx(Tooltip, {
    placement: "top",
    ariaType: "label",
    body: audio.isPlaying || audio.isLoading ? "Stop afspilning" : "Start afspilning af lydfil",
    disabled: props.disabled,
    children: ref => /*#__PURE__*/jsx(CircularButton, {
      ref: ref,
      className: cx(button, props.className, props.disabled && "disabled"),
      iconKey: icon.key,
      icon: icon.element,
      onClick: onClick,
      size: props.size,
      children: /*#__PURE__*/jsx("svg", {
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: props.size === "small" ? "0 0 30 30" : "0 0 35 35",
        className: cx(progressCircle, currentProgress && "visible"),
        children: /*#__PURE__*/jsx("path", {
          d: describeArcPath(props.size === "small" ? 30 : 35, 2, Math.min(359.99, Math.round(currentProgress * 360)))
        }, "progress")
      })
    })
  });
}

export { CircledAudioPlayer };
//# sourceMappingURL=_audio-player.circled.js.map
